module.exports = __webpack_public_path__ + "img/10.f360a02.png";